import React, { useState } from "react";
import "../../style/popupform.css";
import { Col, DatePicker, Form, Input, Modal, Row, Select } from "antd";
import moment from "moment";
import { selectUpcomingMeetingsFilters } from "slices/dashboardSlice";
import { useSelector } from "react-redux";
import enUS from "antd/lib/calendar/locale/en_US";
import AddToCalendar from "react-add-to-calendar";
const { Option } = Select;

const timezones = [
  "HST — United States (Hawaii)",
  "AKST — United States (Alaska)",
  "PST — United States (Pacific)",
  "MST — United States (Mountain)",
  "CST — United States (Central)",
  "EST — United States (Eastern)",
  "AST — Canada (Atlantic)",
  "NST — Canada (Newfoundland)",
  "GMT — United Kingdom",
  "WET — Portugal",
  "CET — Germany, France, Spain",
  "EET — Greece, Egypt, South Africa",
  "MSK — Russia (Moscow)",
  "GST — United Arab Emirates",
  "PKT — Pakistan",
  "IST — India",
  "NPT — Nepal",
  "BST — Bangladesh",
  "ICT — Thailand, Vietnam, Cambodia",
  "WIB — Indonesia (Western)",
  "WITA — Indonesia (Central)",
  "WIT — Indonesia (Eastern)",
  "CST — China",
  "HKT — Hong Kong",
  "SGT — Singapore",
  "JST — Japan",
  "KST — South Korea",
  "AWST — Australia (Western)",
  "ACST — Australia (Central)",
  "AEST — Australia (Eastern)",
  "NZST — New Zealand"
];

const PopupForm = ({ onSave, onCancel, formData }) => {
  
  const [form] = Form.useForm();
  const [timezone, setTimezone] = useState("PST"); 

  const meetingType = useSelector(selectUpcomingMeetingsFilters)
  const meetingOptionsFull = {
    ...meetingType,
    // "OTH": "Other",
  };
  
  const initialValues = {
    meetingId: formData?.id ? formData?.id : "",
    meeting_name: formData?.title ? formData?.title : "",
    meetingDateTime: formData?.date ? moment(`${formData?.date} ${formData?.time}`) : "",
    meetingType: formData?.type ? formData?.type : "",
    timezone: formData?.timezone ? formData?.timezone : "",
  };
  const [selectedMeetingType, setSelectedMeetingType] = useState(null);

  // console.log('sss formData', formData, initialValues);

  const handleTimezoneChange = (value) => {
    setTimezone(value);
  };


  const onSubmit = (values) => {
    const meetingData = { ...values };
    onSave(meetingData);
    onCancel()
  };

  const customLocale = {
    ...enUS,
    lang: {
      ...enUS.lang,
      ok: 'Save', // <-- Change this to whatever you want
    },
  };

  return (
    <Modal
      title=""
      footer={null}
      visible={true}
      onCancel={onCancel}
      width="590px"
      // closeIcon={<CloseOutlined className="close-icon" />}
    >
      <h2 className="modal-title">New Meeting</h2>
      <Form form={form} name="upcoming_meeting_form" initialValues={initialValues} onFinish={onSubmit} layout="vertical">

        <Row>
          <Col span={24}>
            <p hidden style={{ marginBottom: "10px", fontSize: "17px" }}>Meeting ID</p>
            <Form.Item name="meetingId" hidden> 
              <Input readOnly style={{ padding: "13.5px 11px", backgroundColor: "#E8F4F7", border: "1px solid #007bff" }} />
            </Form.Item>
          </Col>
          <Col span={24}>
            <p style={{ marginBottom: "10px", fontSize: "17px" }}>Meeting Name</p>
            <Form.Item name="meeting_name" rules={[{ required: true, message: "Required Field" }]}> 
              <Input name="meeting_name" style={{ padding: "13.5px 11px", lineHeight: "40px", boxSizing: "border-box", backgroundColor: "#E8F4F7", border: "1px solid #007bff" }} />
            </Form.Item>
          </Col>
          <Col span={24}>
            <Row>
              <Col span={12}>
                <p style={{ marginBottom: "10px", fontSize: "17px" }}>Meeting Date & Time</p>
                <Form.Item name="meetingDateTime" rules={[{ required: true, message: "Required Field" }]}> 
                  <DatePicker disabledDate={(current) => current && current < moment().startOf('day')} showTime={{ use12Hours: true, format: 'hh:mm A' }} format="MM/DD/YYYY hh:mm A" locale={customLocale} name="meetingDateTime" style={{ padding: "13.5px 11px", boxSizing: "border-box", width: "100%", backgroundColor: "#E8F4F7", border: "1px solid #007bff" }} />
                </Form.Item>
              </Col>
              <Col span={12} style={{paddingLeft: "10px"}}>
                <p style={{ marginBottom: "10px", fontSize: "17px" }}>Timezone</p>
                <Form.Item name="timezone" rules={[{ required: true, message: "Required Field" }]}> 
                  <Select 
                    value={timezone} 
                    onChange={handleTimezoneChange} 
                    style={{ boxSizing: "border-box", width: "100%" }}
                    name="timezone"
                  >
                    {timezones.map((tz) => (
                      <Option key={tz} value={tz}>{tz}</Option>
                    ))}
                  </Select>
                </Form.Item>
              </Col>
            </Row>
          </Col>
          <Col span={24}>
            <Row>
              <Col span={selectedMeetingType === "OTH" ? 12 : 24}>
                <p style={{ marginBottom: "10px", fontSize: "17px" }}>Meeting Type</p>
                <Form.Item name="meetingType" rules={[{ required: true, message: "Required Field" }]}>
                  <Select placeholder="Select a meeting type" onChange={(value) => setSelectedMeetingType(value)} style={{ boxSizing: "border-box", width: selectedMeetingType === "OTH" ? "100%" : "50%" }}>
                    {
                      Object.entries(meetingOptionsFull).map(([key,value]) => {
                        return <Option key={key} value={key}>{value}</Option>
                      })
                    }
                  </Select>
                </Form.Item>
              </Col>
            {/* {selectedMeetingType === "OTH" && (
              <Col span={12} style={{paddingLeft: "10px"}}>
                <p style={{ marginBottom: "10px", fontSize: "17px" }}>Other Meeting Type</p>
                <Form.Item name="otherMeetingType" rules={[{ required: true, message: "Required Field" }]}>
                  <Input
                    name="otherMeetingType"
                    placeholder="Specify your meeting type"
                    style={{
                      padding: "13.5px 11px",
                      lineHeight: "40px",
                      boxSizing: "border-box",
                      backgroundColor: "#E8F4F7",
                      border: "1px solid #007bff",
                      width: selectedMeetingType === "OTH" ? "100%" : "50%",
                    }}
                  />
                </Form.Item>
              </Col>
            )} */}
            </Row>
          </Col>
          {/* <Col span={24}>
          {
            React.createElement(() => (
              <AddToCalendar
                // event={addToCal}
                listItems={[{google: "Add to Google Calendar"}]}
                optionsOpen={true}
              />
            ))
          }
          </Col> */}

          <Col span={24}>
            <div className="button-group">
              <button className="button-secondary" style={{width: "25%"}} onClick={onCancel}>Cancel</button>
              <button className="button-main" htmlType="submit" style={{width: "25%"}}>Save</button>
            </div>
          </Col>
        </Row>

      </Form>

    </Modal>
  );
};

export default PopupForm;
